import api from "./api";

const MailjetAPI = {
    getDashboardStats: () => api.get("/mailjet/dashboard-stats"),
    getAllContact: () => api.get("/mailjet/contact/all")
};

export default MailjetAPI;